import React, { useEffect, useState } from "react";
import PaulService from "../../services/paul";
import { getDomain, DEFAULT_ENV } from "../../constants";
import EnvironmentSelector from "../options/environment_selector";

const mrlab_data = require("./mrlab_data.json");
const rcpj_data = require("./rcpj_data.json");
const mrhpno_data = require("./mrhpno_data.json");
const mrprc_data = require("./mrprc_data.json");

const paramsByEnv = {
  development: {
    userType: 'delegate',
    userId: {
      delegate: "usr_sta_OyDk9fpMPjzy",
      manager: "usr_sta_3VdjCGTru6nX"
    },
    mrlab: {
      productId: "prod_sta_NTQaCbZeDYjP",
      baseData: mrlab_data
    },
    rcpj: {
      productId: "prod_sta_Goqar9iK8qam",
      baseData: rcpj_data
    },
    mrhpno: {
      productId: "prod_sta_LsQ9zf7xjBtT",
      baseData: mrhpno_data
    },
    mrprc: {
      productId: "prod_sta_iJuzB6M7EMS2",
      baseData: mrprc_data
    },
    publicApiToken: {
      delegate: "rwkM8ggv7PRPaCwtq5ZDxY35",
      manager: "mJkCgCqTBspWDps7r2GseKks"
    }
  },
  staging: {
    userType: 'delegate',
    userId: {
      delegate: "usr_sta_OyDk9fpMPjzy",
      manager: "usr_sta_3VdjCGTru6nX"
    },
    mrlab: {
      productId: "prod_sta_NTQaCbZeDYjP",
      baseData: mrlab_data
    },
    rcpj: {
      productId: "prod_sta_Goqar9iK8qam",
      baseData: rcpj_data
    },
    mrhpno: {
      productId: "prod_sta_LsQ9zf7xjBtT",
      baseData: mrhpno_data
    },
    mrprc: {
      productId: "prod_sta_iJuzB6M7EMS2",
      baseData: mrprc_data
    },
    publicApiToken: {
      delegate: "rwkM8ggv7PRPaCwtq5ZDxY35",
      manager: "mJkCgCqTBspWDps7r2GseKks"
    },
  },
  validation: {
    userType: 'delegate',
    userId: {
      delegate:"usr_val_SjjcYID1af8t",
      manager:"usr_val_M3odvZHDe31E"
    },
    mrlab: {
      productId: "prod_val_tS2m4L74zQE3",
      baseData: mrlab_data
    },
    rcpj: {
      productId: "prod_val_rcxdI3ETw3PU",
      baseData: rcpj_data
    },
    mrhpno: {
      productId: "prod_val_gxc2IoaL0dka",
      baseData: mrhpno_data
    },
    mrprc: {
      productId: "prod_val_8pmvKM8APpEa",
      baseData: mrprc_data
    },
    publicApiToken: {
      delegate: "iZfsnFUM3knJbnQUotGzbXSZ",
      manager: "QSZE1xMdFA3NNqvY7RC2EA8H"
    }
  }
};

const MadpDemo = () => {
  const [loading, setLoading] = useState(false);
  const [token, setToken] = useState(null);
  const [requestId, setRequestId] = useState(null);
  const [environment, setEnvironment] = useState(DEFAULT_ENV);
  const [product, setProduct] = useState("mrlab");
  const [userKind, setUserKind] = useState("delegate");
  const [effectDate, setEffectDate] = useState("2026-12-31");
  const domain = getDomain(environment);

  const changeEnvironment = (env) => {
    setEnvironment(env);
  };

  useEffect(() => {
    changeEnvironment(DEFAULT_ENV);
  }, []);

  const createEmbed = async (e) => {
    e.preventDefault();
    setLoading(true);
    const paulService = new PaulService(environment, true, paramsByEnv[environment].publicApiToken.delegate);
    mrlab_data.antenia_raw_data.devis.date_effet = effectDate;
    rcpj_data.antenia_raw_data.devis.date_effet = effectDate;
    mrhpno_data.antenia_raw_data.devis.date_effet = effectDate;
    mrprc_data.antenia_raw_data.devis.date_effet = effectDate;
    const { id } = await paulService.createCR(
        environment,
        paramsByEnv[environment].userId.delegate,
        paramsByEnv[environment][product].productId,
        paramsByEnv[environment][product].baseData,
        false
    );
    setRequestId(id)
    const token = await paulService.createRequestUserToken(
        environment,
        paramsByEnv[environment].userId.delegate,
        id
    );
    setToken(token);
    setLoading(false);
  };

  const getEmbed = async (e) => {
    e.preventDefault();
    setLoading(true);
    const paulService = new PaulService(environment, true, paramsByEnv[environment]["publicApiToken"][userKind]);
    const token = await paulService.createRequestUserToken(
        environment,
        paramsByEnv[environment]["userId"][userKind],
        requestId
    );
    setToken(token);
    setLoading(false);
  };

  if (loading) {
    return <p style={{ textAlign: "center" }}>Loading...</p>;
  }
  return (
      <div className="App" style={{ height: "100%" }}>
        <h1>MADP Demo</h1>
        {!token && (
            <>
              <EnvironmentSelector
                  value={environment}
                  onChange={(env) => changeEnvironment(env)}
              />
              <div>
                <label style={{marginRight: "10px"}}>Product:</label>
                <select
                    onChange={(e) => {
                      setProduct(e.target.value);
                    }}
                >
                  <option value="mrlab">MRLAB</option>
                  <option value="rcpj">RCPJ</option>
                  <option value="mrhpno">MRHPNO</option>
                  <option value="mrprc">MRPRC</option>
                </select>
              </div>
              <div>
                <label style={{marginRight: "10px"}}>Effect date:</label>
                <input
                    type="text"
                    value={effectDate}
                    onChange={(e) => setEffectDate(e.target.value)}
                />
              </div>

              <button onClick={createEmbed} style={{marginTop: "10px", marginBottom: "10px"}}>
                Create request
              </button>

              <div>
                <label style={{marginRight: "10px"}}>Request id:</label>
                <input
                    type="text"
                    value={requestId}
                    onChange={(e) => setRequestId(e.target.value)}
                />
              </div>
              <div>
                <label style={{marginRight: "10px"}}>User kind:</label>
                <select
                    onChange={(e) => {
                      setUserKind(e.target.value);
                    }}
                >
                  <option value="delegate">Délégataire</option>
                  <option value="manager">Gestionnaire</option>
                </select>
              </div>
              <button onClick={getEmbed} style={{marginTop: "10px"}}>
                Get request
              </button>
            </>
        )}
        {token && (
            <div>
              <h3>Embed {requestId} ({userKind}):</h3>
              <div
                  className="container"
                  style={{width: "1024px", height: "768px", margin: "0 auto"}}
              >
                <iframe
                    title="Insurgate"
                    src={`${domain}?rut=${token}&theme=madp`}
                    width="100%"
                    height="100%"
                />
              </div>
            </div>
        )}
      </div>
  );
};

export default MadpDemo;
